<template>
    <aside>
        <header>
            <ProfileBackground :color="config.COLOR_PRIMARY"/>
            <div class="info">
                <router-link :to="{ name: 'profile' }">
                    <ProfilePicture :src="user.picture" color="white"/>
                </router-link>
                <h4>
                    {{ user.displayName }}
                </h4>
                <h5 v-if="user.email">
                    {{ user.email }}
                </h5>
            </div>
        </header>
        <nav>
            <ul>
                <li v-for="(route, n) in routes" :key="n">
                    <router-link :to="route.to">
                        <component :is="route.icon"/> {{ route.name }}
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'profile' }">
                        <IconProfile/> {{ config.NAVBAR_PROFILE }}
                    </router-link>
                </li>
                <li>
                    <a to="#" @click="onLogout">
                        <IconLogout/> {{ config.NAVBAR_LOGOUT }}
                    </a>
                </li>
            </ul>
        </nav>
        <footer>
            <ul>
                <li>
                    <a :href="linkFacebook" target="facebook">
                        <IconFacebook :color="config.COLOR_PRIMARY"/>
                    </a>
                </li>
                <li>
                    <a :href="linkInstagram" target="instagram">
                        <IconInstagram :color="config.COLOR_PRIMARY"/>
                    </a>
                </li>
                <li>
                    <a :href="linkTwitter" target="twitter">
                        <IconTwitter :color="config.COLOR_PRIMARY"/>
                    </a>
                </li>
            </ul>
        </footer>
    </aside>
</template>
<script>
import { SolutionConsumer, UserConsumer, CoreConsumer } from '../../mixins';
import { ProfilePicture } from '../../components/mobile';

export default {
    name: 'Sidebar',
    components: { ProfilePicture },
    mixins: [SolutionConsumer, UserConsumer, CoreConsumer],
    computed: {
        linkFacebook () {
            return this.config.NAVBAR_FACEBOOK || 'https://www.facebook.com/teester';
        },
        linkInstagram () {
            return this.config.NAVBAR_INSTAGRAM || 'https://www.instagram.com/teester';
        },
        linkTwitter () {
            return this.config.NAVBAR_TWITTER || 'https://twitter.com/teester';
        },
    },
    methods: {
        onLogout () {
            this.logout();
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

aside {
    @include flex-vertical();
    background-color: $white;

    > header {
        position: relative;
        color: $white;

        > .info {
            @include flex-vertical();
            @include cover();
            position: absolute;
            justify-content: center;
            align-items: center;
            text-align: center;

            > h4, > h5 {
                margin: 0;
                font-weight: normal;
                color: inherit;
            }
        }
    }

    > nav {
        flex-grow: 1;

        > ul {
            list-style-type: none;
            padding: 0;
            margin: 0;

            > li {
                color: $grey-darkest;

                > a {
                    display: flex;
                    align-items: center;
                    padding: 16px 8px;
                    text-transform: uppercase;
                    text-decoration: none;
                    font-size: 14px;
                    font-weight: bold;
                    letter-spacing: 1px;
                    cursor: pointer;

                    > svg {
                        @include square(32px);
                        margin: 0 16px;
                        fill: $grey-darkest;
                    }
                }

                &:hover {
                    background-color: $grey-darkest;
                    color: $white;

                    svg {
                        fill: $white;
                    }
                }
            }
        }
    }

    > footer {
        display: flex;
        justify-content: center;

        > ul {
            @include ul-horizontal(48px);
            margin-bottom: 16px;

            > li {
                > a {
                    @include a-reset();

                    > svg {
                        @include square(24px);
                    }
                }
            }
        }
    }
}
</style>
